import { ValidatorFn, AbstractControl, ValidationErrors } from '@angular/forms';

export function matchPasswordValidator(controlName: string, matchingControlName: string, controlChecker: string | null = null ): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const formGroup = control;
    // console.log('form here==>',formGroup);
    
    if (!formGroup) {
      return null;
    }
    let hasChecker = false
    if(controlChecker){
      hasChecker = formGroup.get(controlChecker)?.value === true
    }
    const controlValue = formGroup.get(controlName)?.value ;
    const matchingControlValue = formGroup.get(matchingControlName)?.value;
    return (!hasChecker && (String(controlValue) == '' || String(matchingControlValue) == '' || String(controlValue) != String(matchingControlValue) )) ? { passwordsNotMatch: true } : null

    // if ((String(controlValue) != String(matchingControlValue) ) == true) {
    //   return { passwordsNotMatch: true };
    // } else {
    //   return null;
    // }
  };
}
